import { Globe2 } from 'lucide-react';

export default function BrandLogo({ compact = false }) {
  return (
    <div className="landing-logo" aria-label="CatRUS">
      <span className="landing-logo-mark" aria-hidden="true"><Globe2 size={compact ? 17 : 19} /></span>
      <span className="landing-logo-name">Cat<span>RUS</span></span>
    </div>
  );
}
